import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Button, Container } from 'reactstrap';
import { sendVirtualPageView } from '../../../shared/utility';
import useJuryData from '../JuryProjectsList/useJuryData';
import useJuryStore from '../../../store/juryStore';
import JuryProjectsGrid from '../JuryProjectsList/JuryProjectsGrid';
import styles from './JuryFinalVoteSubmission.module.scss';

function JuryFinalVoteSubmission() {
    useJuryData(); // triggers one-time fetch

    const projects = useJuryStore(s => s.projects);
    const votes = useJuryStore(s => s.votes);
    const voteLimit = useJuryStore(s => s.voteLimit);

    useEffect(() => {
        sendVirtualPageView("Jury - Abstimmung");
    }, []);

    // Only show projects with at least one point assigned
    const votedProjects = projects.filter(p => (votes[p._id] || 0) > 0);

    const usedPoints = Object.values(votes).reduce((s, v) => s + v, 0);
    const remainingPoints = voteLimit - usedPoints;

    const handleSubmit = () => {
        // TODO: implement final submission
    };

    return (
        <>
            <Helmet>
                <title>Jury-Voting - Abstimmung</title>
            </Helmet>
            <JuryProjectsGrid
                projects={votedProjects}
                showCount={false}
                showDeleteButton={true}
                emptyMessage="Sie haben noch keinem Projekt Punkte vergeben."
            />
            <Container className={styles.SubmitSection}>
                <p className={styles.RemainingText}>
                    Es sind noch {remainingPoints} von {voteLimit} Punkten zu vergeben
                </p>
                <Button
                    color="primary"
                    className={styles.SubmitButton}
                    onClick={handleSubmit}
                >
                    Punktevergabe bestätigen
                </Button>
            </Container>
        </>
    );
}

export default JuryFinalVoteSubmission;
